import { Component, OnInit, AfterViewInit, Renderer, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { JhiLanguageService, EventManager } from 'ng-jhipster';

import { Account, LoginService, Principal } from '../shared';
import { StateStorageService } from '../shared/auth/state-storage.service';
import { PasswordResetService } from '../shared/login/password-reset.service';
import { TRAINING } from '../app.constants';
import {EventManagerService} from '../shared/services/event-manager.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [
    'login.scss'
  ]
})
export class LoginComponent implements OnInit, AfterViewInit {

  authenticationError: boolean;
  password: string;
  rememberMe: boolean;
  username: string;
  credentials: any;
  account: Account;
  loading: boolean;
  loginForm: boolean;

  resetAccount: {email: string};
  success: string;
  resetPasswordEmailFocus = false;
  error: string;
  errorEmailNotExists: string;

  trainingSystem = TRAINING;

  constructor(
    private eventManager: EventManager,
    private emService: EventManagerService,
    private languageService: JhiLanguageService,
    private loginService: LoginService,
    private stateStorageService: StateStorageService,
    private elementRef: ElementRef,
    private renderer: Renderer,
    private router: Router,
    private principal: Principal,
    private passwordResetService: PasswordResetService,
  ) {
    this.credentials = {};
    this.resetAccount = {email: ''};
    this.loginForm = true;
    // Toggle sidebar once to disable remaining sidebar artifacts
    this.emService.broadcast({
      name: 'toggleSidebar',
      content: 'Toggle Sidebar'
    });
  }

  ngOnInit() {
    this.languageService.addLocation('login');
  }

  ngAfterViewInit() {
    this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#username'), 'focus', []);
  }

  cancel() {
    this.credentials = {
      username: null,
      password: null,
      rememberMe: true
    };
    this.authenticationError = false;
  }

  login() {
    this.loading = true;
    this.loginService.login({
      username: this.username,
      password: this.password,
      rememberMe: this.rememberMe
    }).then(() => {
      this.authenticationError = false;
      this.loading = false;
      if (this.router.url === '/register' || (/activate/.test(this.router.url)) ||
        this.router.url === '/finishReset' || this.router.url === '/requestReset') {
        this.router.navigate(['']);
      }
      // Enable sidebar
      this.emService.broadcast({
        name: 'toggleSidebar',
        content: 'Toggle Sidebar'
      });
      this.eventManager.broadcast({
        name: 'authenticationSuccess',
        content: 'Sending Authentication Success'
      });

      // // previousState was set in the authExpiredInterceptor before being redirected to login modal.
      // // since login is succesful, go to stored previousState and clear previousState
      const redirect = this.stateStorageService.getUrl();
      if (redirect) {
        this.router.navigate([redirect])
          .then(s => (!s) ? this.navigateErr(s) : null)
          .catch(e => this.navigateErr(e));
      } else {
        this.router.navigate(['/'])
          .then(s => (!s) ? this.navigateErr(s) : null)
          .catch(e => this.navigateErr(e));
      }
    }).catch(() => {
      this.authenticationError = true;
      this.loading = false;
    });
  }

  navigateErr(error) {
    console.log('redirect error', error);
    this.authenticationError = true;
  }

  register() {
    this.router.navigate(['/register']);
  }

  requestResetPassword() {
    this.router.navigate(['/reset', 'request']);
  }

  toggleForm() {
    this.loginForm = !this.loginForm;
    if (this.loginForm) {
      this.success = null;
      this.resetAccount = {email: ''};
    }
  }

  requestReset() {
    this.error = null;
    this.errorEmailNotExists = null;

    this.passwordResetService.save(this.resetAccount.email).subscribe(() => {
      this.success = 'OK';
      this.resetAccount = {email: ''};
    }, (response) => {
      this.success = null;
      if (response.status === 400 && response._body === 'email address not registered') {
        this.errorEmailNotExists = 'ERROR';
      } else {
        this.error = 'ERROR';
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts